import './PaperlessPreferencesIndicatorView.scss';

import React, {Fragment} from 'react'
import { ReactComponent as CheckImage } from 'assets/icons/green-check.svg';
import { ReactComponent as CloseImage } from 'assets/icons/close.svg'
import {
  TradeMark,
  UnsupedRegistered
} from "services/Content";
const PaperlessPreferencesIndicatorView = ({paperlessPreferencesStatus}) => {
  const activeAccountComponents = {
    Advisory: <>Retirement Advisory Service<TradeMark className="document-indicator-tradeMark" /> Communications</>,
    ActivePlus: <>ActivePlus Portfolios<UnsupedRegistered /> Communications</>
  }
  return (
    <Fragment>
      {paperlessPreferencesStatus && paperlessPreferencesStatus.length > 0 && (
        <div className="document-indicator-view">
          <div className="document-indicator-header">
            {' '}
            Your current paperless preferences:
          </div>
          {paperlessPreferencesStatus.map((obj, index) => {
            const { label, isAllPaperless } = obj;
            return (
              <Fragment key={index}>
                {isAllPaperless ? (
                  <div className="document-indicator-label">
                    <CheckImage className="label-checkmark"></CheckImage>
                    <div className="document-indicator-text">
                      {label in activeAccountComponents
                        ? activeAccountComponents[label]
                        : label}
                    </div>
                  </div>
                ) : (
                  <div className="document-indicator-label">
                    <CloseImage className="label-close"></CloseImage>
                    <div className="document-indicator-text-false">
                      {label in activeAccountComponents
                        ? activeAccountComponents[label]
                        : label}
                    </div>
                  </div>
                )}
              </Fragment>
            );
          })}
        </div>
      )}
    </Fragment>
  );
}

export default PaperlessPreferencesIndicatorView